import { useState, useEffect, useCallback } from "react";
import { Chip, TableCell } from "@mui/material";
import "../../Styles/style.css";
import "./Ticket.css";
import AdminApiModule from "../../components/AdminApi/Api/api";
import { Button } from "@mui/material";
import TicketEditPincodePopup from "../../components/AdminApi/ticketEditPincodePopup";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
// import BasicDateRangePicker from "../../components/common/datepicker";
import { withRouter } from "../../utility/withRouter";
import moment from "moment";
import { connect } from "react-redux";
import CloseTicketRemarksModal from "../../components/Components/CloseTicketRemark";
import AssignTechnicianPopup from "../../components/AdminApi/Api/assignTechnicianPopup";
import RemarksPopup from "../../components/AdminApi/Api/RemarksPopup";
import DeleteAlertDialogModal from "../../components/Components/DeleteAlert";
import DeleteIcon from "@mui/icons-material/Delete";
import UpdateIcon from "@mui/icons-material/Update";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/styles";
import FileUploadErrors from "../../components/FileUploadErrors";
import axios from "axios";
import { BASE_URL } from "../../components/config/config";
import InputBase from "@mui/material/InputBase";
import { withStyles } from "@mui/styles";
import RebookModal from "../../components/Components/RebookMoadl";
import MUIDataTable from "mui-datatables";
import {
  canViewClosedTickets,
  canUpdateTicket,
  canDeleteTicket,
  canAssignUnassignTicket,
  canBroadcastTicket,
  canCloseTicket,
  canRemarkTicket,
  canViewContactNumber,
  hasFullAccess,
} from "../../utility/permissionUtils";
import CloseTicketFilter from "./Filters/CloseTicketFilter";

const CustomFilter = withStyles({
  filter: {
    background: "red",
  },
})(InputBase);

const Input = styled("input")({
  display: "none",
});

const stylesCss = {
  inputBox: {
    width: "100%",
    marginBottom: "10px",
  },
  gridStyle: {
    width: "80%",
    margin: "auto",
  },
  paddingInnerGrids: {
    paddingRight: "10px",
    paddingLeft: "10px",
    paddingTop: "10px",
  },
};

const options = {
  filterType: "dropdown",
  filter: true,
  download: true,
  downloadOptions: {
    filterOptions: {
      useDisplayedRowsOnly: true,
      useDisplayedColumnsOnly: true,
    },
  },
  customFilterMenuRender: (filterValue, onFilterUpdate, column) => {
    return (
      <CustomFilter
        value={filterValue || ""}
        onChange={(event) => onFilterUpdate(event.target.value)}
        placeholder={`Filter ${column.label}`}
      />
    );
  },
  downloadProps: {
    filterOptions: {
      useDisplayedRowsOnly: true,
      useDisplayedColumnsOnly: true,
    },
  },
};

const CloseTicket = ({ router, reduxState }) => {
  // State declarations
  const [ticketsList, setTicketsList] = useState([]);
  const [ticketObj, setTicketObj] = useState([]);
  const [centerlist, setCenterlist] = useState([]);
  const [isEditOpenAddressPincode, setIsEditOpenAddressPincode] =
    useState(false);
  const [isEditOpenTicketDetails, setIsEditOpenTicketDetails] = useState({});
  const [isPincodeUpdating, setIsPincodeUpdating] = useState(false);
  const [getSingleTicketData, setGetSingleTicketData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [doesFileUploadErrorExists, setDoesFileUploadErrorExists] =
    useState(false);
  const [errorsList, setErrorsList] = useState({});
  const [selectedRowsClosingPrice, setSelectedRowsClosingPrice] = useState({});
  const [totalClosingPrice, setTotalClosingPrice] = useState(0);
  const [selectedTicketIds, setSelectedTicketIds] = useState([]);
  const [isApiButtonVisible, setIsApiButtonVisible] = useState(false);
  const [isAssignTechnicianPopupOpen, setIsAssignTechnicianPopupOpen] =
    useState(false);
  const [isRemarksPopupOpen, setIsRemarksPopupOpen] = useState(false);
  const [isDeleteAlertPopupOpen, setIsDeleteAlertPopupOpen] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("Ticket");
  const [
    ticketDetailsForAssignTechnician,
    setTicketDetailsForAssignTechnician,
  ] = useState({});
  const [isTechnicianAssigning, setIsTechnicianAssigning] = useState(false);
  const [technicianList, setTechnicianList] = useState([]);
  const [isCloseTicketRemarksModalOpen, setIsCloseTicketRemarksModalOpen] =
    useState(false);
  const [closingTicketId, setClosingTicketId] = useState("");
  const [deleteTicketId, setDeleteTicketId] = useState("");
  const [rebookTicketId, setRebookTicketId] = useState("");
  const [centerAssignId, setCenterAssignId] = useState("");
  const [isForChange, setIsForChange] = useState(false);
  const [openRebook, setOpenRebook] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [username, setUsername] = useState("");
  const [initialRemarks, setInitialRemarks] = useState("");
  const [processedname, setProcessedname] = useState("");
  // const [activeFilters, setActiveFilters] = useState({});

  const [activeFilters, setActiveFilters] = useState(() => {
    const savedFilters = localStorage.getItem("closeTicketActiveFilters");
    return savedFilters ? JSON.parse(savedFilters) : {};
  });

  // Helper method to get user permissions
  const getUserPermissions = useCallback(() => {
    return reduxState?.adminDetails?.role_id?.permissions || {};
  }, [reduxState]);

  // Check if user has access to view closed tickets
  const hasAccessToClosedTickets = useCallback(() => {
    const permissions = getUserPermissions();
    return canViewClosedTickets(permissions) || hasFullAccess(permissions);
  }, [getUserPermissions]);

  // Save activeFilters to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem(
      "closeTicketActiveFilters",
      JSON.stringify(activeFilters)
    );
  }, [activeFilters]);

  // Handle filter submission
  const handleFilterSubmit = useCallback((filters) => {
    setActiveFilters(filters);
    getAllClosedTickets(filters);
  }, []);

  // Handle clear filters
  const handleClearFilters = useCallback(() => {
    setActiveFilters({});
    localStorage.removeItem("closeTicketActiveFilters");
    getAllClosedTickets();
  }, []);

  // Columns definition
  const columns = [
    {
      name: "Created_at",
      label: "Created on",
      options: {
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Created On
          </TableCell>
        ),
        filter: false,
        sort: true,
      },
    },
    {
      name: "assignedAt",
      label: "Assigned on",
      options: {
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Assigned On
          </TableCell>
        ),
        filter: false,
        sort: true,
      },
    },
    {
      name: "closeddate",
      label: "Closed At",
      options: {
        filter: false,
        sort: true,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Closed At
          </TableCell>
        ),
      },
    },
    {
      name: "daysDifference",
      label: "Days to Close",
      options: {
        filter: false,
        sort: true,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Days to Close
          </TableCell>
        ),
      },
    },
    {
      name: "Image",
      label: "On-Site Image",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            On-Site Image
          </TableCell>
        ),
        customBodyRender: (value, id) => {
          return (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "auto auto auto auto",
                gridGap: "-10px !important",
              }}
            >
              {value && value.length > 0 && (
                <Button
                  className="text-transform-none"
                  variant="contained"
                  onClick={() => handleViewwTicket(value, value?._id)}
                >
                  Views
                </Button>
              )}
            </div>
          );
        },
      },
    },
    {
      name: "ticket_id",
      label: "Ticket Id",
      options: {
        filter: false,
        sort: true,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Request Id
          </TableCell>
        ),
      },
    },
    {
      name: "serial_number",
      label: "Serial Number",
      options: {
        filter: false,
        sort: true,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Serial Number
          </TableCell>
        ),
      },
    },
    {
      name: "code",
      label: "Happy Code",
      options: {
        filter: false,
        sort: true,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Happy Code
          </TableCell>
        ),
      },
    },
    {
      name: "tstatus",
      label: "Ticket status",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Request status
          </TableCell>
        ),
        customBodyRender: (value) => {
          return value == "Technician Assigned" ? (
            <Chip label={value} style={{ background: "#8FD1AD" }} />
          ) : (
            <Chip
              label={value}
              style={{
                background:
                  value == "PENDING"
                    ? "#FF9933"
                    : value == "Technician Not Assigned"
                    ? "#E76161"
                    : value == "VERIFIED"
                    ? "#00CC00"
                    : value == "CLOSED"
                    ? "#FF9999"
                    : "red",
              }}
            />
          );
        },
      },
    },
    {
      name: "bstatus",
      label: "Broadcast status",
      options: {
        filter: true,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Broadcast status
          </TableCell>
        ),
      },
    },
    {
      name: "paidbypublic",
      label: "Paid By Public",
      options: {
        filter: true,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Paid By Public
          </TableCell>
        ),
      },
    },
    {
      name: "paidbytechnician",
      label: "Paid By technician",
      options: {
        filter: true,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Paid By Technician
          </TableCell>
        ),
      },
    },
    {
      name: "technician_id",
      label: "Assigned technician",
      options: {
        filter: false,
        sort: true,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Assigned technician
          </TableCell>
        ),
      },
    },
    {
      name: "center_qr_id",
      label: "Center QR Id ",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Center_QR
          </TableCell>
        ),
      },
    },
    {
      name: "specific_requirements",
      label: "Specific Requirements",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Specific Requirements
          </TableCell>
        ),
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Name
          </TableCell>
        ),
      },
    },
    {
      name: "locality",
      label: "Locality",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Locality
          </TableCell>
        ),
      },
    },
    {
      name: "city",
      label: "City",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            City
          </TableCell>
        ),
      },
    },
    {
      name: "state",
      label: "State",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            State
          </TableCell>
        ),
      },
    },
    {
      name: "pincode",
      label: "Pincode",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Pincode
          </TableCell>
        ),
      },
    },
    {
      name: "phone",
      label: "Phone",
      options: {
        filter: false,
        sort: false,
        display: canViewContactNumber(getUserPermissions()) ? "true" : "none",
        customHeadRender: () => (
          <TableCell
            style={{
              fontSize: "17px",
              fontWeight: "600",
              width: canViewContactNumber(getUserPermissions()) ? "auto" : "0",
              padding: canViewContactNumber(getUserPermissions())
                ? "normal"
                : "0",
              display: canViewContactNumber(getUserPermissions())
                ? "table-cell"
                : "none",
            }}
            align="center"
          >
            Phone
          </TableCell>
        ),
      },
    },
    {
      name: "alternate_phone",
      label: "Alternate Phone",
      options: {
        filter: false,
        sort: false,
        display: canViewContactNumber(getUserPermissions()) ? "true" : "none",
        customHeadRender: () => (
          <TableCell
            style={{
              fontSize: "17px",
              fontWeight: "600",
              width: canViewContactNumber(getUserPermissions()) ? "auto" : "0",
              padding: canViewContactNumber(getUserPermissions())
                ? "normal"
                : "0",
              display: canViewContactNumber(getUserPermissions())
                ? "table-cell"
                : "none",
            }}
            align="center"
          >
            Alternate Phone
          </TableCell>
        ),
      },
    },
    {
      name: "closingPrice",
      label: "Closing Price",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Closing Price
          </TableCell>
        ),
      },
    },
    {
      name: "tcreatedby",
      label: "Ticket Created By",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Request Created By
          </TableCell>
        ),
      },
    },
    {
      name: "timeprefrence",
      label: "Ticket Created By",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Timeprefrence
          </TableCell>
        ),
      },
    },
    {
      name: "action",
      label: "Actions",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const permissions = getUserPermissions();
          const canUpdate =
            canUpdateTicket(permissions) || hasFullAccess(permissions);
          const canDelete =
            canDeleteTicket(permissions) || hasFullAccess(permissions);
          const canAssign =
            canAssignUnassignTicket(permissions) || hasFullAccess(permissions);
          const canBroadcast =
            canBroadcastTicket(permissions) || hasFullAccess(permissions);
          const canClose =
            canCloseTicket(permissions) || hasFullAccess(permissions);
          const canRemark =
            canRemarkTicket(permissions) || hasFullAccess(permissions);

          return (
            <>
              <div style={{ display: "flex", width: "900px" }}>
                <Button
                  sx={{
                    fontSize: "12px !important",
                    marginRight: "15px !important",
                  }}
                  variant="contained"
                  onClick={() => handleViewTicket(value?._id)}
                >
                  View Request
                </Button>

                {canUpdate && (
                  <Button
                    sx={{
                      fontSize: "12px !important",
                      marginRight: "15px !important",
                    }}
                    variant="contained"
                    onClick={() => handleEditTicket(value?._id)}
                  >
                    Edit Request
                  </Button>
                )}

                {value?.is_technician_assigned &&
                value?.ticket_status !== "CLOSED" ? (
                  <>
                    {canAssign && (
                      <Button
                        sx={{
                          fontSize: "10px !important",
                          marginRight: "15px !important",
                        }}
                        variant="contained"
                        onClick={() => {
                          handleOpenTechnicianPopup(value, true);
                        }}
                        disabled={!value?.service_available}
                      >
                        Reassign Technician
                      </Button>
                    )}
                    {canClose && (
                      <Button
                        sx={{
                          fontSize: "10px !important",
                          marginRight: "15px !important",
                        }}
                        onClick={() =>
                          clickCloseTicket(
                            value?._id,
                            value?.assigned_ids?.assigned_center_id?._id,
                            value?.ticket_id
                          )
                        }
                        variant="contained"
                        color="primary"
                        disabled={
                          !value?.service_available ||
                          !value?.assigned_ids?.assigned_center_id?._id
                        }
                      >
                        Close Ticket
                      </Button>
                    )}
                  </>
                ) : (
                  ""
                )}
                {!value?.is_technician_assigned ? (
                  <>
                    {canAssign && (
                      <Button
                        sx={{
                          fontSize: "10px !important",
                          marginRight: "15px !important",
                        }}
                        variant="contained"
                        onClick={() => {
                          sameINA(value, (centerlist) => {
                            handleOpenTechnicianPopup(value, false, centerlist);
                          });
                        }}
                      >
                        Assign Technician
                      </Button>
                    )}
                    {canBroadcast && (
                      <Button
                        sx={{
                          fontSize: "10px !important",
                          marginRight: "15px !important",
                        }}
                        variant="contained"
                        onClick={() => {
                          handleBroadcastButtonClick(value?._id);
                        }}
                      >
                        Broadcast
                      </Button>
                    )}
                  </>
                ) : (
                  ""
                )}
                {canDelete && (
                  <Tooltip title="Delete">
                    <Button
                      style={{ background: "#FCE9F1" }}
                      onClick={() => clickDeleteTicket(value?._id)}
                    >
                      <DeleteIcon style={{ color: "red" }} />
                    </Button>
                  </Tooltip>
                )}

                {value?.ticket_status == "CLOSED" && canUpdate && (
                  <>
                    <Tooltip title="Rebook">
                      <Button
                        style={{
                          background: "#FCE9F1",
                          marginLeft: "10px",
                        }}
                        onClick={() => handleRebookOpen(value?._id)}
                      >
                        <UpdateIcon style={{ color: "green" }} />
                      </Button>
                    </Tooltip>
                  </>
                )}

                {canRemark && (
                  <Button
                    sx={{
                      fontSize: "12px !important",
                      marginLeft: "10px !important",
                      marginRight: "15px !important",
                      backgroundColor: value?.remarks?.onboarding_team_remarks
                        ? "green !important"
                        : "FCE9F1 !important",
                    }}
                    onClick={() =>
                      handleRemarks(
                        value?._id,
                        reduxState.adminDetails.user_name,
                        value?.remarks?.onboarding_team_remarks,
                        value?.remarks?.onboarding_team_name
                      )
                    }
                    variant="contained"
                  >
                    Remarks
                  </Button>
                )}

                <RemarksPopup
                  open={isRemarksPopupOpen}
                  handleClose={handleCloseRemarksPopup}
                  onSaveRemarks={handleSaveRemarks}
                  selectedTicketId={selectedTicketId}
                  username={username}
                  initialRemarks={initialRemarks}
                  processedname={processedname}
                />
              </div>
            </>
          );
        },
      },
    },
  ];

  // Event handlers
  const handleRemarks = (ticketId, username, initialRemarks, processedname) => {
    const permissions = getUserPermissions();
    if (!canRemarkTicket(permissions) && !hasFullAccess(permissions)) {
      return;
    }

    setSelectedTicketId(ticketId);
    setUsername(username);
    setInitialRemarks(initialRemarks);
    setProcessedname(processedname);
    setIsRemarksPopupOpen(true);
  };

  const handleCloseRemarksPopup = () => {
    setIsRemarksPopupOpen(false);
    setSelectedTicketId(null);
  };

  const handleSaveRemarks = (ticketId, remarks, username) => {
    handleCloseRemarksPopup();
  };

  const handleBroadcastButtonClick = (id) => {
    const permissions = getUserPermissions();
    if (!canBroadcastTicket(permissions) && !hasFullAccess(permissions)) {
      return;
    }

    const apiUrl = `${BASE_URL}technicianApp/ticket-broadcast`;
    const requestData = {
      ticket_obj_id: id,
    };

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        console.log("Ticket broadcasted successfully");
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const handleEditTicket = (id) => {
    const permissions = getUserPermissions();
    if (!canUpdateTicket(permissions) && !hasFullAccess(permissions)) {
      return;
    }

    router.navigate("/admin-ticket?edit=" + id);
  };

  const handleViewTicket = (id) => {
    window.open(`/#/view-ticket?ticketId=${id}`, '_blank');
  };

  const handleViewwTicket = (images, id) => {
    router.navigate({
      pathname: "/ticketDocument",
      query: { ticketId: id?.rowData && id?.rowData[20] },
      state: { imageUrls: images, ticketId: id },
    });
  };

  const fetchMultipleImages = (data) => {
    const allImages = data.reduce((images, item) => {
      return images.concat(item.onsite_pictures || []);
    }, []);

    router.navigate({
      pathname: "/ticketDocument",
      state: { imageUrls: allImages },
    });
  };

  const clickCloseTicket = (ticket_obj_id, centerAssignId, ticketId) => {
    const permissions = getUserPermissions();
    if (!canCloseTicket(permissions) && !hasFullAccess(permissions)) {
      return;
    }

    const ticket_Id = localStorage.getItem("tickeClose_Id");
    const ticketID = localStorage.getItem("ticketId");
    const payload = {
      ticket_obj_id: ticket_obj_id,
    };

    if (ticket_Id) {
      new AdminApiModule().getSingleTicket(payload).then((res) => {
        setGetSingleTicketData(res?.data);
      });
    }

    setClosingTicketId(ticket_obj_id);
    setCenterAssignId(centerAssignId);
    handleOpenCloseTicketRemarksModal(ticket_obj_id, centerAssignId);
    localStorage.setItem("tickeClosetId", ticketId);
    localStorage.setItem("tickeClose_Id", ticket_obj_id);
  };

  const clickDeleteTicket = (ticketId) => {
    const permissions = getUserPermissions();
    if (!canDeleteTicket(permissions) && !hasFullAccess(permissions)) {
      return;
    }

    setDeleteTicketId(ticketId);
    handleOpenCloseTicketDeleteModal(ticketId);
    localStorage.setItem("ticketId", ticketId);
  };

  const sameINA = (ticketDetails, callback) => {
    const permissions = getUserPermissions();
    if (!canAssignUnassignTicket(permissions) && !hasFullAccess(permissions)) {
      return;
    }

    const payload = {
      ticket_obj_id: ticketDetails._id,
    };

    const apiUrl = `${BASE_URL}admin/get-center-for-ticket`;

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((res) => {
        callback(res.data);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const handleOpenTechnicianPopup = (
    ticketDetails,
    isForChangeValue,
    centerlist
  ) => {
    const permissions = getUserPermissions();
    if (!canAssignUnassignTicket(permissions) && !hasFullAccess(permissions)) {
      return;
    }

    setIsAssignTechnicianPopupOpen(true);
    setTicketDetailsForAssignTechnician(ticketDetails);
    setIsForChange(isForChangeValue);
    setCenterlist(centerlist);
  };

  const handleCloseAssignTechnicianPopup = () => {
    setIsAssignTechnicianPopupOpen(false);
    setTicketDetailsForAssignTechnician({});
  };

  const handleOpenCloseTicketRemarksModal = () => {
    setIsCloseTicketRemarksModalOpen(true);
  };

  const handleOpenCloseTicketDeleteModal = () => {
    setIsDeleteAlertPopupOpen(true);
  };

  const onClickFilter = (value) => {
    if (!hasAccessToClosedTickets()) {
      return;
    }

    startLoading();

    let payload = {
      start_date: value[0],
      end_date: value[1],
    };

    new AdminApiModule()
      .getAllClosedTickets(payload)
      .then((res) => {
        let parsedData = [];
        if (res?.data?.length) {
          parsedData = getParsedData(res.data);
        }
        setTicketsList(parsedData);
        stopLoading();
      })
      .catch((err) => {
        stopLoading();
        console.log(err);
      });
  };

  const refreshData = useCallback(() => {
    getAllClosedTickets(activeFilters);
  }, [activeFilters]);

  const startLoading = () => {
    setIsLoading(true);
  };

  const stopLoading = () => {
    setIsLoading(false);
  };

  const handleBroadCastTicket = (value) => {
    const permissions = getUserPermissions();
    if (!canBroadcastTicket(permissions) && !hasFullAccess(permissions)) {
      return;
    }

    let payload = {
      ticket_obj_id: value?._id,
    };
    new AdminApiModule()
      .adminBroadCast(payload)
      .then((res) => {
        getAllClosedTickets();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCloseTicket = useCallback(
    (closingTicketRemarks, closingPrice, closingCode, reasonToClose) => {
      const permissions = getUserPermissions();
      if (!canCloseTicket(permissions) && !hasFullAccess(permissions)) {
        return;
      }

      if (!(closingPrice == 0 || closingPrice)) {
        return;
      }

      if (closingTicketId && closingTicketId.length > 0) {
        let payload = {
          center_id: centerAssignId,
          ticket_obj_id: closingTicketId,
          remarks: {
            close_ticket_remarks: reasonToClose,
            technician_remarks: closingTicketRemarks,
          },
          amount: parseInt(closingPrice),
          code: closingCode,
        };

        new AdminApiModule()
          .closeTicket(payload)
          .then((res) => {
            setClosingTicketId("");
            handleCloseCloseTicketRemarksModal();
            showDialog(true, "success", "Ticket closed successfully");
            getAllClosedTickets(activeFilters); // Use active filters
          })
          .catch((err) => {
            console.log(err);
            showDialog(true, "error", err?.response?.data?.message);
          });
      }
    },
    [closingTicketId, centerAssignId, activeFilters, getUserPermissions]
  );

  const handleRevisitCloseTicket = useCallback(
    (
      closingTicketRemarks,
      closingPrice,
      closingCode,
      reasonToClose,
      revisitRemark
    ) => {
      const permissions = getUserPermissions();
      if (!canCloseTicket(permissions) && !hasFullAccess(permissions)) {
        return;
      }

      if (!(closingPrice == 0 || closingPrice)) {
        return;
      }

      if (closingTicketId && closingTicketId.length > 0) {
        let payload = {
          center_id: centerAssignId,
          ticket_obj_id: closingTicketId,
          remarks: {
            close_ticket_remarks: reasonToClose,
            technician_remarks: closingTicketRemarks,
            revisit_remarks: revisitRemark,
          },
          amount: parseInt(closingPrice),
          code: closingCode,
        };

        new AdminApiModule()
          .closeTicket(payload)
          .then((res) => {
            setClosingTicketId("");
            handleCloseCloseTicketRemarksModal();
            showDialog(true, "success", "Ticket closed successfully");
            getAllClosedTickets(activeFilters); // Use active filters
          })
          .catch((err) => {
            console.log(err);
            showDialog(true, "error", err?.response?.data?.message);
          });
      }
    },
    [closingTicketId, centerAssignId, activeFilters, getUserPermissions]
  );

  const handleAssignTechnician = useCallback(
    (technician_obj_id) => {
      const permissions = getUserPermissions();
      if (
        !canAssignUnassignTicket(permissions) &&
        !hasFullAccess(permissions)
      ) {
        return;
      }

      if (!technician_obj_id) {
        return;
      }

      setIsTechnicianAssigning(true);
      let payload = {
        ticket_obj_id: ticketDetailsForAssignTechnician._id,
        technician_obj_id: technician_obj_id,
      };

      new AdminApiModule()
        .assignTechnician(payload)
        .then((res) => {
          handleCloseAssignTechnicianPopup();
          setIsTechnicianAssigning(false);
          getAllClosedTickets(activeFilters); // Use active filters
        })
        .catch((err) => {
          setIsTechnicianAssigning(false);
          console.log(err);
        });
    },
    [ticketDetailsForAssignTechnician, activeFilters, getUserPermissions]
  );

  const handleChangeTechnician = useCallback(
    (technician_obj_id) => {
      const permissions = getUserPermissions();
      if (
        !canAssignUnassignTicket(permissions) &&
        !hasFullAccess(permissions)
      ) {
        return;
      }

      if (!technician_obj_id) {
        return;
      }

      setIsTechnicianAssigning(true);
      let payload = {
        ticket_obj_id: ticketDetailsForAssignTechnician._id,
        technician_obj_id: technician_obj_id,
      };

      new AdminApiModule()
        .changeTechnician(payload)
        .then((res) => {
          handleCloseAssignTechnicianPopup();
          setIsTechnicianAssigning(false);
          getAllClosedTickets(activeFilters); // Use active filters
        })
        .catch((err) => {
          setIsTechnicianAssigning(false);
          console.log(err);
        });
    },
    [ticketDetailsForAssignTechnician, activeFilters, getUserPermissions]
  );

  const getAllTechnician = () => {
    new AdminApiModule()
      .getAllTechnician()
      .then((res) => {
        setTechnicianList(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleOpenEditPincodePopup = (value) => {
    const permissions = getUserPermissions();
    if (!canUpdateTicket(permissions) && !hasFullAccess(permissions)) {
      return;
    }

    setIsEditOpenAddressPincode(true);
    setIsEditOpenTicketDetails(value);
  };

  const handleApiCall = () => {
    setSelectedTicketIds([]);
  };

  const handleCloseEditPincodePopup = () => {
    setIsEditOpenAddressPincode(false);
    setIsEditOpenTicketDetails({});
  };

  const getFormattedAddress = (addressObject) => {
    let addressLine =
      addressObject?.house_number +
      ", " +
      addressObject?.locality +
      ", " +
      addressObject?.city +
      ", " +
      addressObject?.state;
    return addressLine;
  };

  const getParsedData = (data) => {
    let parsedData = data?.map((item) => {
      let closingPrice = item?.closing_ticket_price;
      if (closingPrice === "-" || closingPrice === undefined) {
        closingPrice = 0;
      } else {
        closingPrice = parseFloat(closingPrice);
      }

      return {
        Created_at: new Date(item?.createdAt).toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        }),
        assignedAt: item?.assignedAt
          ? new Date(item?.assignedAt).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
              hour12: true,
            })
          : "-",
        closeddate: item?.closedAt
          ? new Date(item?.closedAt).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
              hour12: true,
            })
          : "-",
        updatedAt: item?.updatedAt
          ? new Date(item?.updatedAt).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
              hour12: true,
            })
          : "-",
        daysDifference: moment(item?.updatedAt).diff(
          moment(item?.createdAt),
          "days"
        ),
        Image: item?.onsite_pictures,
        serial_number: item?.serial_number || "-",
        ticket_id: item?.ticket_id || "-",
        Qr_Id: item?.assigned_ids?.assigned_center_id?.qr_details?.qr_id || "-",
        offer_code: item?.offers_applied?.offer_code || "-",
        center_id: item?.assigned_ids?.assigned_center_id?.center_name,
        center_qr_id:
          item?.assigned_ids?.assigned_center_id?.qr_details?.qr_id || "-",
        technician_id:
          item?.assigned_ids?.assigned_technician_id?.personal_details?.name,
        service_required: `${item?.service_provided_for?.service_name.slice(
          0,
          30
        )}...`,
        name: item.personal_details.name,
        locality: item.address_details.locality,
        city: item.address_details.city,
        state: item.address_details.state,
        pincode: item.address_details.pincode,
        phone: item.personal_details.primary_phone.mobile_number,
        alternate_phone: item.personal_details.alternate_phone?.mobile_number,
        address: `${getFormattedAddress(item?.address_details).slice(
          0,
          30
        )}...`,
        pincode: item.address_details.pincode,
        createdAt: new Date(item?.createdAt).toLocaleDateString("en-us", {
          year: "numeric",
          month: "short",
          day: "numeric",
        }),
        paidbypublic: item?.is_paid_by_public ? "99" : "0",
        client_id: item?.client_id || "-",
        client_name: item?.client_name || "-",
        specific_requirements: item?.specific_requirement
          ? item?.specific_requirement
          : "-",
        bstatus:
          item?.service_available == false
            ? "No Service Available In This Area "
            : item?.broadcast_status == "broadcasted" &&
              item?.ticket_created_by == "CENTER"
            ? "NEW NOT PAID"
            : item?.broadcast_status == "broadcasted" &&
              item?.ticket_created_by == "PUBLIC_WITH_DELAR_QR"
            ? "DEALER"
            : item?.ticket_created_by == "SUPER_ADMIN" &&
              item?.broadcast_status == "accepted after broadcast"
            ? "Admin Created-Accepted"
            : item?.broadcast_status == "accepted after broadcast"
            ? "Public Created-Accepted"
            : item?.broadcast_status == undefined
            ? "Not Paid (Payment Failed)"
            : item?.broadcast_status == "broadcasted"
            ? `NEW ${
                (item?.is_paid_by_public == true && "99") ||
                (item?.is_paid_by_public == false &&
                  item?.ticket_created_by === "PUBLIC_WITH_CENTER_QR" &&
                  "NOT PAID")
              }`
            : `${item?.broadcast_status} FREE` ||
              (item?.broadcast_status === undefined && "-"),
        tstatus: item?.ticket_status,
        code: item?.remarks?.message === "happy_code" ? "Yes" : "No",
        tcreatedby: item?.ticket_created_by,
        Rating: item?.remarks?.over_all_rating,
        action: item,
        closingPrice: closingPrice,
        timeprefrence: item?.time_preference?.specific_date_time
          ? new Date(item.time_preference.specific_date_time).toLocaleString(
              "en-IN",
              {
                timeZone: "Asia/Kolkata",
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                hour12: true,
              }
            )
          : item?.time_preference?.time_preference_type,
        paidbytechnician: item?.is_paid_by_technician ? "99" : "0",
        Center_QR: item?.created_by?.qr_details?.qr_id,
      };
    });

    return parsedData;
  };

  const getAllClosedTickets = useCallback(
    (filters = activeFilters) => {
      if (!hasAccessToClosedTickets()) {
        return;
      }

      startLoading();

      const queryParams = new URLSearchParams();

      // Add filter parameters
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          // Convert boolean to string if needed
          const paramValue =
            typeof value === "boolean" ? value.toString() : value;
          queryParams.append(key, paramValue);
        }
      });

      // Use your existing API module or fetch directly
      const apiUrl = `${BASE_URL}admin/get-all-close-ticket?${queryParams.toString()}`;

      fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((res) => {
          let parsedData = [];
          if (res?.data?.length) {
            parsedData = getParsedData(res.data);
          }
          setTicketsList(parsedData);
          stopLoading();
        })
        .catch((err) => {
          stopLoading();
          console.log("Error fetching closed tickets:", err);
        });
    },
    [hasAccessToClosedTickets, activeFilters]
  );

  const handleUpdatePincode = useCallback(
    (newPincode) => {
      const permissions = getUserPermissions();
      if (!canUpdateTicket(permissions) && !hasFullAccess(permissions)) {
        return;
      }

      if (!newPincode) {
        return;
      }

      let payload = {
        address_details: {
          pincode: newPincode,
        },
        ticket_obj_id: isEditOpenTicketDetails?._id,
      };

      setIsPincodeUpdating(true);
      new AdminApiModule()
        .updatePincode(payload)
        .then((res) => {
          setIsPincodeUpdating(false);
          getAllClosedTickets(activeFilters); // Use active filters
          handleCloseEditPincodePopup();
        })
        .catch((err) => {
          setIsPincodeUpdating(false);
        });
    },
    [isEditOpenTicketDetails, activeFilters, getUserPermissions]
  );

  const onUploadCsvFile = (event, stateValue) => {
    let files = event.target.files;
    let aadharSideName = event.target.name;
    let fileOriginalName = files[0]?.name?.split(".")[0];

    const formData = new FormData();
    formData.append("ticketsCsvFile", files[0], fileOriginalName);

    new AdminApiModule()
      .uploadTicketsCsv(formData)
      .then((res) => {
        if (res && res.data && res.data.doesErrorExists) {
          setDoesFileUploadErrorExists(true);
          setErrorsList(res.data.errorRowWise);
        } else {
          getAllClosedTickets();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateSelectedRowsClosingPrice = () => {
    let totalClosingPrice = 0;
    const selectedRowsClosingPrice = {};

    selectedTicketIds.forEach((ticketId) => {
      const rowData = ticketsList.find((row) => row.ticket_id === ticketId);
      if (rowData && rowData.closingPrice) {
        const closingPrice = parseFloat(rowData.closingPrice);
        if (!isNaN(closingPrice)) {
          totalClosingPrice += closingPrice;
          selectedRowsClosingPrice[ticketId] = closingPrice;
        }
      }
    });

    setSelectedRowsClosingPrice(selectedRowsClosingPrice);
    setTotalClosingPrice(totalClosingPrice);
  };

  const handleCloseFileUploadErrors = () => {
    setDoesFileUploadErrorExists(false);
    setErrorsList({});
  };

  const handleCloseCloseTicketRemarksModal = () => {
    setIsCloseTicketRemarksModalOpen(false);
  };

  const handleDeleteCloseModal = () => {
    setIsDeleteAlertPopupOpen(false);
  };

  const handleDeleteRows = useCallback(async () => {
    const permissions = getUserPermissions();
    if (!canDeleteTicket(permissions) && !hasFullAccess(permissions)) {
      return;
    }

    let accessToken = localStorage.getItem("access_token");
    let ticket_id = localStorage.getItem("ticketId");

    try {
      await axios.delete(`${BASE_URL}admin/deleteTickets/${ticket_id}`, {
        headers: {
          "x-access-token": accessToken,
        },
      });
      handleDeleteCloseModal();
      getAllClosedTickets(activeFilters); // Use active filters
    } catch (error) {
      console.log(error);
    }
  }, [activeFilters, getUserPermissions]);

  const handlePageChange = async (event, page) => {
    setCurrentPage(page);
    let showNo = pageSize;
    let currentsPage = currentPage;
    let total = 5 + currentPage;
    await getAllTicket(total, currentsPage);
  };

  const handleDeleteSelectedRows = () => {
    selectedTicketIds.forEach((ticketId) => {
      clickDeleteTicket(ticketId);
    });
    setSelectedTicketIds([]);
  };

  const handleRebookOpen = (rebookTicketId) => {
    const permissions = getUserPermissions();
    if (!canUpdateTicket(permissions) && !hasFullAccess(permissions)) {
      return;
    }

    setRebookTicketId(rebookTicketId);
    setOpenRebook(true);
  };

  const handleRebookClose = () => setOpenRebook(false);

  const showDialog = (open, type, message) => {
    // Implement dialog logic here
    console.log(message);
  };

  const getAllTicket = async (total, page) => {
    // Implement get all tickets logic here
  };

  // Effects
  useEffect(() => {
    if (!hasAccessToClosedTickets()) {
      return;
    }

    getAllClosedTickets(activeFilters);
    getAllTechnician();
  }, []);

  useEffect(() => {
    updateSelectedRowsClosingPrice();
  }, [selectedTicketIds, ticketsList]);

  // Check if user has access to view closed tickets
  if (!hasAccessToClosedTickets()) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
          fontSize: "18px",
          color: "#666",
        }}
      >
        You don't have permission to view closed tickets. Please contact
        administrator.
      </div>
    );
  }

  return (
    <div>
      <RebookModal
        isOpen={openRebook}
        handleRebookOpen={handleRebookOpen}
        handleRebookClose={handleRebookClose}
        Ticket_id={rebookTicketId}
      />

      {isCloseTicketRemarksModalOpen && (
        <CloseTicketRemarksModal
          open={isCloseTicketRemarksModalOpen}
          handleClose={handleCloseCloseTicketRemarksModal}
          handleCloseTicket={handleCloseTicket}
          handleRevisitCloseTicket={handleRevisitCloseTicket}
          getSingleTicketData={getSingleTicketData?.results}
        />
      )}

      {isEditOpenAddressPincode && (
        <TicketEditPincodePopup
          open={isEditOpenAddressPincode}
          isPincodeUpdating={isPincodeUpdating}
          handleUpdatePincode={handleUpdatePincode}
          handleClose={handleCloseEditPincodePopup}
          isEditOpenTicketDetails={isEditOpenTicketDetails}
        />
      )}

      {isDeleteAlertPopupOpen && (
        <DeleteAlertDialogModal
          openAlert={isDeleteAlertPopupOpen}
          handleAlertClose={handleDeleteCloseModal}
          handleDeleteTicket={handleDeleteRows}
          Heading={deleteHeading}
        />
      )}

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
        onClick={stopLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <CloseTicketFilter
        onFilterSubmit={handleFilterSubmit}
        onClearFilters={handleClearFilters}
        loading={isLoading}
        initialFilters={activeFilters}
      />

      <Grid container justifyContent="flex-end">
        <Grid style={stylesCss.paddingInnerGrids} item>
          <div className="aadhar-upload-button">
            <Button
              variant="contained"
              style={{
                backgroundColor: "green",
                color: "white",
                fontSize: "0.3rem",
                padding: "8px 10px",
                borderRadius: "0",
                marginBottom: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: "38px",
                width: "70px",
              }}
            >
              <h1>PAID</h1>
              <div>
                <h1>{totalClosingPrice}</h1>
              </div>
            </Button>
          </div>
        </Grid>
      </Grid>

      {isAssignTechnicianPopupOpen && (
        <AssignTechnicianPopup
          open={isAssignTechnicianPopupOpen}
          handleClose={handleCloseAssignTechnicianPopup}
          technicianList={technicianList}
          isForChange={isForChange}
          handleAssignTechnician={handleAssignTechnician}
          handleChangeTechnician={handleChangeTechnician}
          isTechnicianAssigning={isTechnicianAssigning}
          centerlist={centerlist}
        />
      )}

      <MUIDataTable
        title={"Closed Requests"}
        data={ticketsList}
        columns={columns}
        options={{
          ...options,
          selectableRows: "multiple",
          onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
            const selectedIds = allRowsSelected.map(
              (row) => ticketsList[row.dataIndex].ticket_id
            );
            setSelectedTicketIds(selectedIds);
          },
        }}
      />

      {doesFileUploadErrorExists && (
        <FileUploadErrors
          doesFileUploadErrorExists={doesFileUploadErrorExists}
          errorsList={errorsList}
          handleCloseFileUploadErrors={handleCloseFileUploadErrors}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  reduxState: state.userReducer,
});

export default connect(mapStateToProps, null)(withRouter(CloseTicket));
